import { createClient } from '@supabase/supabase-js';

// Use process.env for server-side (Vercel) and import.meta.env for client-side (Vite)
const supabaseUrl = typeof process !== 'undefined' && process.env.VITE_SUPABASE_URL 
  ? process.env.VITE_SUPABASE_URL 
  : import.meta.env?.VITE_SUPABASE_URL || '';

const supabaseAnonKey = typeof process !== 'undefined' && process.env.VITE_SUPABASE_ANON_KEY 
  ? process.env.VITE_SUPABASE_ANON_KEY 
  : import.meta.env?.VITE_SUPABASE_ANON_KEY || '';

// Check for missing credentials and provide better error messages
if (!supabaseUrl) {
  console.error("CRITICAL ERROR: Missing Supabase URL. Please check your .env file.");
}

if (!supabaseAnonKey) {
  console.error("CRITICAL ERROR: Missing Supabase Anonymous Key. Please check your .env file.");
}

// Mock Supabase client if credentials are missing (for development only)
let supabase;

try {
  if (supabaseUrl && supabaseAnonKey) {
    supabase = createClient(supabaseUrl, supabaseAnonKey, {
      db: {
        schema: 'public'
      },
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: 'pkce'
      }
    });
  } else {
    // Create a mock client that logs operations but doesn't fail immediately
    console.warn("Creating mock Supabase client for development");
    supabase = {
      from: (table) => ({
        select: () => {
          console.warn(`Mock Supabase: select from ${table}`);
          return Promise.resolve({ data: [], error: new Error("Missing Supabase credentials") });
        },
        insert: () => {
          console.warn(`Mock Supabase: insert into ${table}`);
          return Promise.resolve({ data: null, error: new Error("Missing Supabase credentials") });
        },
        update: () => {
          console.warn(`Mock Supabase: update ${table}`);
          return Promise.resolve({ data: null, error: new Error("Missing Supabase credentials") });
        },
        delete: () => {
          console.warn(`Mock Supabase: delete from ${table}`);
          return Promise.resolve({ data: null, error: new Error("Missing Supabase credentials") });
        }
      }),
      auth: {
        onAuthStateChange: () => {
          console.warn("Mock Supabase: auth state change listener");
          return { data: { subscription: { unsubscribe: () => {} } } };
        },
        getSession: () => {
          console.warn("Mock Supabase: getSession");
          return Promise.resolve({ data: { session: null }, error: new Error("Missing Supabase credentials") });
        }
      }
    };
  }
} catch (error) {
  console.error("Error initializing Supabase client:", error);
  // Provide a fallback mock client
  supabase = {
    from: () => ({
      select: () => Promise.resolve({ data: [], error: new Error("Supabase initialization failed") })
    }),
    auth: {
      onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } })
    }
  };
}

export { supabase }; 